import { render, staticRenderFns } from "./myInvoiceDetail.vue?vue&type=template&id=3aba8cba&scoped=true"
import script from "./myInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./myInvoiceDetail.vue?vue&type=script&lang=js"
import style0 from "./myInvoiceDetail.vue?vue&type=style&index=0&id=3aba8cba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aba8cba",
  null
  
)

export default component.exports